import { render } from "./Websites.vue?vue&type=template&id=42826ce4&scoped=true&ts=true"
import script from "./Websites.vue?vue&type=script&lang=ts"
export * from "./Websites.vue?vue&type=script&lang=ts"

import "./Websites.vue?vue&type=style&index=0&id=42826ce4&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42826ce4"]])

export default __exports__